import { v4 as uuidv4 } from 'uuid';
import { setSimulatorProfiles } from '../redux/simulatorProfilesSlice';
import sortedProfilesAttributes from './sortedProfilesAttributes';
import { setSnackbarMessage } from '../redux/snackbarMessageSlice';

export const handleGetSimulatorProfiles = async (project, profile, subjectSchema, dispatch) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_SIM_URL}/projects/${project?.project_id}/profiles`);
        if (response.ok) {
            const result = await response.json();
            // console.log("Simulator profiles:", result);
            if (result.profiles && result.profiles.length === 0 && result.message === "Project not found") {
                let usedAttributes = {};

                const user_profile = profile;
                for (const attr of subjectSchema) {
                    if (user_profile[attr.name]) {
                        usedAttributes[attr.name] = user_profile[attr.name];
                    }
                }

                const sim_profiles = {
                    project_id: project?.project_id,
                    created_by: profile?.displayName,
                    updated_by: profile?.displayName,
                    profiles: [
                        {
                            id: uuidv4(),
                            name: "unname",
                            created_at: new Date().toISOString(),
                            updated_at: new Date().toISOString(),
                            attributes: usedAttributes,
                        }
                    ]
                }

                // console.log("Profile to be added to simulator:", sim_profiles);

                //Add the new profile to the simulator
                const addResponse = await fetch(`${process.env.REACT_APP_API_SIM_URL}/projects`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(sim_profiles)
                });
                if (!addResponse.ok) {
                    throw new Error("Failed to create simulator project");
                }

                const response2 = await fetch(`${process.env.REACT_APP_API_SIM_URL}/projects/${project?.project_id}/profiles`);
                if (response2.ok) {
                    const result = await response2.json();
                    dispatch(setSimulatorProfiles(sortedProfilesAttributes(result.profiles) || []));
                    return;
                } else {
                    throw new Error("Failed to create simulator profiles");
                }
            } else if (result.profiles && result.profiles.length === 0 && result.message === "Profile not found") {
                let usedAttributes = {};

                const user_profile = profile;
                for (const attr of subjectSchema) {
                    if (user_profile[attr.name]) {
                        usedAttributes[attr.name] = user_profile[attr.name];
                    }
                }

                const newProfile = {
                    id: uuidv4(),
                    name: "unname",
                    created_at: new Date().toISOString(),
                    updated_at: new Date().toISOString(),
                    attributes: usedAttributes,
                };

                const response2 = await fetch(`${process.env.REACT_APP_API_SIM_URL}/projects/${project?.project_id}/profiles`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(newProfile)
                });

                if (response2.ok) {
                    const result2 = await response2.json();
                    const updatedProfiles = [...result.profiles, newProfile];
                    dispatch(setSimulatorProfiles(sortedProfilesAttributes(updatedProfiles) || []));
                    return;
                } else {
                    throw new Error("Failed to add simulator profile");
                }
            }
            dispatch(setSimulatorProfiles(sortedProfilesAttributes(result.profiles) || []));
            return;
        } else {
            throw new Error("Failed to fetch simulator profiles");
        }
    } catch (error) {
        console.error(error.message);
        dispatch(setSnackbarMessage({
            open: true,
            message: error.message,
            status: "error",
        }));
        return;
    };
};